var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14067_724)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5186 10.2134C11.9684 10.2134 12.346 10.5846 12.2772 11.0288C11.8737 13.6422 9.63648 15.5825 6.93824 15.5825C3.95297 15.5825 1.53333 13.1629 1.53333 10.1783C1.53333 7.71937 3.4014 5.42885 5.50455 4.91095C5.95648 4.79937 6.41964 5.11727 6.41964 5.58253C6.41964 8.73481 6.52561 9.55025 7.1242 9.99376C7.7228 10.4373 8.42666 10.2134 11.5186 10.2134Z",
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4617 7.5884C14.4975 5.56314 12.0097 2.29858 8.97816 2.35472C8.74237 2.35893 8.5536 2.55542 8.54308 2.79051C8.46659 4.45577 8.56974 6.61367 8.62729 7.59191C8.64483 7.89647 8.88413 8.13577 9.18799 8.15332C10.1936 8.21086 12.4301 8.28946 14.0715 8.04103C14.2947 8.00735 14.4582 7.81367 14.4617 7.5884Z",
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14067_724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.954102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.afed9dc104d6cef758a9825d3dca9dc4.svg";
export { ForwardRef as ReactComponent };